<template>
  <div>
    <MeestReturnsHead
        :countFilterParams="countFilterParams"
        :showFilter="showFilter"
        :selectedNow="selectedNow"
        @toggleFilter="toggleFilter"
        @selectAll="(val) => {selectedNow = val}"
        @filter="$emit('filter')"
        @reload="$emit('reload')"
        @createConsolidationMeest="$emit('createConsolidationMeest')"
        @massThermalPrint="$emit('massThermalPrint')"
    />

    <div class="table-filter-wrap">

      <MeestReturnsFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <MeestReturnsList
          :selectedNow="selectedNow"
          :countFilterParams="countFilterParams"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @updateTable="$emit('updateTable')"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import MeestReturnsHead from "./MeestReturnsHead/MeestReturnsHead";
  import MeestReturnsList from "./MeestReturnsList/MeestReturnsList";
  import MeestReturnsFilter from "./MeestReturnsFilter/MeestReturnsFilter";

  export default {
    name: "MeestReturnsListUser",

    components: {
      MeestReturnsHead,
      MeestReturnsList,
      MeestReturnsFilter,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    watch: {
      filterGetParams(newVal) {
        this.filterGetParams = newVal
      },
      countFilterParams(newVal) {
        this.countFilterParams = newVal
      },
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

    }
  }
</script>

<style scoped>

</style>


